import { EmployeeSchedule } from '@/helpers/workingPattern/employeeSchedule';
import { FC } from 'react';
import { dayIndexes } from '../../../../../helpers/dayIndexes';
import strings from '../../../team.translations';
import { TeamMemberScheduleEditFormRow } from './TeamMemberScheduleEditFormRow';

interface ScheduleGridProps {
  getDaySchedule: (dayNumber?: number) => EmployeeSchedule[];
  canAddSplitPeriod: (dayNumber?: number) => boolean;
  onCheck: (scheduleDay: EmployeeSchedule) => () => void;
  onStartChange: (scheduleDay: EmployeeSchedule) => (newVal?: string) => void;
  onEndChange: (scheduleDay: EmployeeSchedule) => (newVal?: string) => void;
  onAdd: (scheduleDay: EmployeeSchedule) => () => void;
  onDelete: (scheduleDay: EmployeeSchedule) => () => void;
}

export const ScheduleGrid: FC<ScheduleGridProps> = ({
  getDaySchedule,
  canAddSplitPeriod,
  onCheck,
  onStartChange,
  onEndChange,
  onAdd,
  onDelete
}) => {
  return (
    <div
      className="grid grid-cols-3 gap-y-4 gap-x-2 sm:gap-x-6"
      style={{ gridTemplateColumns: 'minmax(120px, auto) minmax(0, 1.65fr) minmax(0, 1.65fr)' }}
    >
      <div></div>
      <p className="text-center">{strings.editSchedule.availableFrom}</p>
      <p className="text-center">{strings.editSchedule.availableUntil}</p>
      {dayIndexes.flatMap(dayNumber => {
        const daySchedule = getDaySchedule(dayNumber);

        return daySchedule.map((item, index) => (
          <TeamMemberScheduleEditFormRow
            key={`${item.dayNumber}-${item.slotNumber}`}
            schedule={item}
            showDayLabel={index === 0}
            onCheck={index === 0 ? onCheck(item) : undefined}
            onStartChange={onStartChange(item)}
            onEndChange={onEndChange(item)}
            canAdd={index === 0 && canAddSplitPeriod(item.dayNumber)}
            canDelete={daySchedule.length > 1}
            onAdd={onAdd(item)}
            onDelete={onDelete(item)}
            addButtonLabel={strings.editSchedule.addAvailabilityPeriod}
            deleteButtonLabel={strings.editSchedule.deleteAvailabilityPeriod}
          />
        ));
      })}
    </div>
  );
};
